import React, { useEffect, useState } from "react";
import star from "../assets/images/StarFour.png";
import b1 from "../assets/images/logo-branding/b1.png";
import b4 from "../assets/images/logo-branding/b4.png";
import b6 from "../assets/images/logo-branding/b6.png";
import ui1 from "../assets/images/ui/UI-1.png";
import ui4 from "../assets/images/ui/UI-4.png";
import ui5 from "../assets/images/ui/UI-5.png";
import ui6 from "../assets/images/ui/UI-6.png";
import ui7 from "../assets/images/ui/UI-7.png";
import ui8 from "../assets/images/ui/UI-8.png";
import ui9 from "../assets/images/ui/UI-9.png";
import ui11 from "../assets/images/ui/UI-11.png";
import ui12 from "../assets/images/ui/UI-12.png";
import ui14 from "../assets/images/ui/UI-14.png";
import ui15 from "../assets/images/ui/UI-15.png";
import ui17 from "../assets/images/ui/UI-17.png";
import an1 from "../assets/images/Animation/Shan.png";
import an3 from "../assets/images/Animation/Kurkure.png";
import an5 from "../assets/images/Animation/MAGAL.png";
import an6 from "../assets/images/Animation/Moro.png";
import an7 from "../assets/images/Animation/Nationals-Food.png";
import an8 from "../assets/images/Animation/Nescafe.png";
import an9 from "../assets/images/Animation/PSO.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import axios from "axios";

export const FourthSec = () => {
  const [activeWorkSectionTabs, setActiveWorkSectionTabs] = useState(0);
  const [visibleImages, setVisibleImages] = useState(9);
  const [visibleAllImages, setVisibleAllImages] = useState(3);

  const workSection = [
    { title: "All", content: "This is the content of Tab 1" },
    { title: "UI/UX DESIGN", content: "This is the content of Tab 2" },
    { title: "LOGO & BRANDING", content: "This is the content of Tab 3" },
    { title: "ANIMATION", content: "This is the content of Tab 4" },
  ];

  const allSec = [
    ui1,
    an3,
    ui4,
    b4,
    an5,
    ui11,
    ui7,
    an6,
    ui5,
    b6,
    an7,
    an8,
    ui14,
    an1,
    ui6,
    ui8,
    ui9,
  ];

  const images = [
    ui1,
    ui4,
    ui5,
    ui6,
    ui7,
    ui8,
    ui9,
    ui11,
    ui12,
    ui14,
    ui15,
    ui17,
  ];

  const [allShuffled, setAllShuffled] = useState([]);
  const [uiux, setUiux] = useState([]);
  const [logoBranding, setLogoBranding] = useState([]);
  const [animation, setAnimation] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [uiuxRes, logoRes, animRes] = await Promise.all([
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/portolio-uixifies?populate=image"
          ),
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/logo-and-branding-uixifies?populate=image"
          ),
          axios.get(
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/animation-uixifies?populate=image"
          ),
        ]);

        const allData = [
          ...uiuxRes.data.data,
          ...logoRes.data.data,
          ...animRes.data.data,
        ];

        // Remove duplicates by checking IDs
        const uniqueData = allData.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
        );

        // Shuffle array
        const shuffled = uniqueData
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);

        setAllShuffled(shuffled);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAll();
  }, []);

  useEffect(() => {
    axios
      .get(
        "https://brilliant-family-61fde61fa1.strapiapp.com/api/portolio-uixifies?populate=image"
      )
      .then((res) => {
        setUiux(res.data.data); // Data array mila
      })
      .catch(console.error);
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://brilliant-family-61fde61fa1.strapiapp.com/api/logo-and-branding-uixifies?populate=image"
      )
      .then((res) => {
        setLogoBranding(res.data.data); // Data array mila
      })
      .catch(console.error);
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://brilliant-family-61fde61fa1.strapiapp.com/api/animation-uixifies?populate=image"
      )
      .then((res) => {
        setAnimation(res.data.data); // Data array mila
      })
      .catch(console.error);
  }, []);

  // Handle responsive image count
  useEffect(() => {
    const handleResize = () => {
      const isMediumScreen = window.innerWidth >= 768; // Tailwind 'md' breakpoint
      setVisibleImages(isMediumScreen ? 9 : 4);
      setVisibleAllImages(isMediumScreen ? 6 : 3); // Set initial visible count based on screen size
    };

    handleResize(); // Set on initial render
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLoadMore = () => {
    setVisibleImages((prev) => prev + 15);
  };

  const handleLoadBack = () => {
    setVisibleImages((prev) => Math.max(prev - 15, 9)); // Prevent going below 9
  };

  useEffect(() => {
    const handleResize = () => {
      const isMediumScreen = window.innerWidth >= 768; // Tailwind 'md' breakpoint
      setVisibleAllImages(isMediumScreen ? 6 : 4);
    };

    handleResize(); // Set on initial render
    window.addEventListener("resize", handleResize); // Update on resize

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLoadImgMore = () => {
    setVisibleAllImages((prev) => prev + 15);
  };

  const handleLoadImgBack = () => {
    setVisibleAllImages((prev) => Math.max(prev - 15, 9)); // Prevent going below 9
  };
  return (
    <>
      <div id="blogs" className="container px-2 m-auto py-[40px]">
        <h2 className=" md:text-[90px] text-[45px] font-black uppercase  size-fit">
          Creativity in <span className="text-[#7467fe]">action</span>
        </h2>
        <div>
          <div className="flex gap-2">
            {[...Array(3)].map((_, index) => (
              <img
                key={index}
                alt="Star"
                src={star}
                className="object-contain w-auto"
              />
            ))}
          </div>
          <p className="text-[16px] md:text-[18px] text-[#6f6f6f] mt-3 tracking-wide">
            Sure, anyone can claim to be creative. But at UIXIFY, we prefre to
            let our work do the talking. From sleek, Intuitive design to
            jawdropping animations and videos that actually get watched, our
            porfolio showcase the results we're proud of. Take a look at what
            we've done-and imagine{" "}
            <span className="uppercase text-[#7467fe]">
              WHat we can do for you.
            </span>
          </p>
        </div>
        {/* </div> */}
        <div>
          <div className="flex justify-evenly flex-wrap mt-8">
            {workSection.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveWorkSectionTabs(index)}
                className={`py-2 px-2 md:text-[18px] text-[10px] font-medium focus:outline-none ${
                  activeWorkSectionTabs === index
                    ? "md:text-[19px] text-[12px] bg-[#c0ff00] rounded-full font-semibold text-black scale-105  border border-black border-b-4 md:w-[243px] "
                    : "text-black hover:scale-105"
                }`}
              >
                {tab.title}
              </button>
            ))}
          </div>
          <div>
            {workSection[activeWorkSectionTabs].title === "All" && (
              <div className="relative">
                <div
                  className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5 relative"
                  style={{
                    mask:
                      visibleAllImages < images.length
                        ? "linear-gradient(to bottom, rgba(0,0,0, 1) 0%, rgba(0,0,0, 1) 40%, rgba(0,0,0, 0) 95%, rgba(0,0,0, 0) 100%)"
                        : "none",
                    WebkitMask:
                      visibleAllImages < images.length
                        ? "linear-gradient(to bottom, rgba(0,0,0, 1) 0%, rgba(0,0,0, 1) 70%, rgba(0,0,0, 0) 100%, rgba(0,0,0, 0) 100%)"
                        : "none",
                    font: "2em/1.6em Arial",
                  }}
                >
                  {allShuffled.slice(0, visibleAllImages).map((item, index) => {
                    const imgUrl = item?.image?.url;
                    const fullUrl = imgUrl?.startsWith("http")
                      ? imgUrl
                      : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`;

                    return (
                      <div key={item.id || index} className="w-full mb-4">
                        <img
                          src={fullUrl}
                          alt={`Portfolio Image ${index + 1}`}
                          className="md:h-full object-contain w-full"
                        />
                      </div>
                    );
                  })}
                </div>
                {visibleAllImages > 2 && (
                  <div className="absolute inset-x-0 bottom-[2px] flex justify-center ">
                    {visibleAllImages < images.length && (
                      <button
                        onClick={handleLoadImgMore}
                        className="flex items-center p-3 bg-[#7366fc] text-white rounded-full mx-2 shadow-lg transition-transform transform hover:scale-105"
                      >
                        <IoIosArrowDown className="text-[50px]" />
                      </button>
                    )}
                  </div>
                )}
                {visibleAllImages > 2 && (
                  <div className=" inset-x-0 bottom-[5%] flex justify-center mb-2">
                    {visibleAllImages >= images.length && (
                      <button
                        onClick={handleLoadImgBack}
                        className="flex items-center p-3 bg-[#7366fc] text-white rounded-full mx-2 shadow-lg transition-transform transform hover:scale-105"
                      >
                        <IoIosArrowUp className="text-[50px]" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {workSection[activeWorkSectionTabs].title === "UI/UX DESIGN" && (
              <div className="relative">
                <div className="relative">
                  <div
                    className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5 relative"
                    style={{
                      mask:
                        visibleImages < uiux.length
                          ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 95%)"
                          : "none",
                      WebkitMask:
                        visibleImages < uiux.length
                          ? "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)"
                          : "none",
                    }}
                  >
                    {uiux.slice(0, visibleImages).map((item, index) => {
                      const imgUrl = item?.image?.url;
                      const fullUrl = imgUrl
                        ? imgUrl
                        : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`;

                      return (
                        <div key={item.id || index} className="relative w-full">
                          <img
                            alt={item.title || `UI design ${index + 1}`}
                            src={fullUrl}
                            className="object-contain w-full transition-opacity"
                          />
                        </div>
                      );
                    })}
                  </div>

                  {visibleImages > 2 && (
                    <div className="absolute inset-x-0 bottom-1/12 flex justify-center">
                      {visibleImages < uiux.length && (
                        <button
                          onClick={handleLoadMore}
                          className="flex items-center p-3 bg-[#7366fc] text-white rounded-full mx-2 shadow-lg transform hover:scale-105"
                        >
                          <IoIosArrowDown className="text-[50px]" />
                        </button>
                      )}
                      {visibleImages >= uiux.length && (
                        <button
                          onClick={handleLoadBack}
                          className="flex items-center p-3 bg-[#7366fc] text-white rounded-full mx-2 shadow-lg transform hover:scale-105"
                        >
                          <IoIosArrowUp className="text-[50px]" />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {workSection[activeWorkSectionTabs].title === "LOGO & BRANDING" && (
              <div>
                <div className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5">
                  {logoBranding.map((item) => {
                    const attr = item.title;
                    const imgUrl = item?.image?.url;
                    return (
                      <div key={item.id} className="w-full">
                        {imgUrl ? (
                          <img
                            src={
                              imgUrl.startsWith("http")
                                ? imgUrl
                                : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                            }
                            alt={attr.title || "Logo"}
                            className="object-contain w-full"
                          />
                        ) : (
                          <div className="bg-gray-200 w-full h-48 flex items-center justify-center">
                            No image
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {workSection[activeWorkSectionTabs].title === "ANIMATION" && (
              <div>
                <div className="grid md:grid-cols-3 grid-cols-2 gap-3 my-5">
                  {animation.map((item) => {
                    const attr = item.title;
                    const imgUrl = item?.image?.url;
                    return (
                      <div key={item.id} className="w-full">
                        {imgUrl ? (
                          <img
                            src={
                              imgUrl.startsWith("http")
                                ? imgUrl
                                : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`
                            }
                            alt={attr.title || "Logo"}
                            className="object-contain w-full"
                          />
                        ) : (
                          <div className="bg-gray-200 w-full h-48 flex items-center justify-center">
                            No image
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
